<template>
  <v-tabs v-model="tab" class="elevation-2" :centered="true" :grow="true">
    <v-tabs-slider></v-tabs-slider>

    <v-tab v-for="i in tabs" :key="i">{{ i.name }}</v-tab>

    <v-tab-item v-for="i in tabs" :key="i">
      <v-card flat tile>
        <v-col class="ds-informe">
          <iframe width="100%" :src="createLink(i.link)" frameborder="0" style="border:0"></iframe>
        </v-col>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import Vue from "vue";
import { oAuth } from "@/classes/Auth.ts";
import { apiv1 } from "@/libs/apiv1.ts";
export default Vue.extend({
  name: "Facturacion",
  data: () => ({
    tab: null,
    urlp: "https://datastudio.google.com/embed/reporting/",
    project: oAuth.getProject().name,
    tabs: []
  }),
  created() {
    this.refresh();
  },
  methods: {
    createLink: function(id) {
      return this.urlp + id;
    },

    refresh: async function() {
      const { data } = await apiv1({
        method: "GET",
        url: `projects/informes/${this.project}`
      });
      console.log(data)
      this.tabs = data;
    },
    ordenar: function(data){

    }
  }
});
</script>

<style lang="scss" scoped>
.ds-informe {
  position: relative;

  &::after {
    width: 100%;
    height: 40px;
    content: " ";
    display: block;
    position: absolute;
    background: #fff;
    bottom: 0;
    left: 0;
  }

  iframe {
    width: 100%;
    height: 80vh;
  }
}
</style>